import PropTypes from 'prop-types';
import React from 'react';
import ToggleButton from 'react-toggle-button';

VistaToggleButton.propTypes = {
    showChart: PropTypes.bool,
    onToggle: PropTypes.func,
};

function VistaToggleButton(props) {
    return (
        <>
            <span className="ml-2 mr-2 toggle-label">Chart</span>
            <ToggleButton
                width={'50px'}
                inactiveLabel={'NO'}
                activeLabel={'YES'}
                value={props.showChart || false}
                colors={{
                    activeThumb: {
                        base: 'rgb(247, 247, 247)',
                    },
                    inactiveThumb: {
                        base: 'rgb(247, 247, 247)',
                    },
                    active: {
                        base: 'rgb(26, 108, 157, 1)',
                        hover: 'rgb(26, 108, 157, 1)',
                    },
                    inactive: {
                        base: 'rgb(65,66,68)',
                        hover: 'rgb(95,96,98)',
                    },
                }}
                onToggle={props.onToggle}
            />
        </>
    );
}

export default VistaToggleButton;
